var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spark 119",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8515 8.45781C21.8606 7.06521 21.7392 5.10407 20.4875 3.85201C19.1336 2.49774 16.9622 2.45941 15.5636 3.74341V3.56455C15.5636 1.59702 13.967 0 12 0C10.033 0 8.4364 1.59702 8.4364 3.56455V3.74341C7.03779 2.4658 4.86642 2.49774 3.51251 3.85201C2.25439 5.11046 2.13305 7.06521 3.14848 8.45781C1.37946 8.66223 0 10.1698 0 11.9968C0 13.9643 1.59659 15.5614 3.5636 15.5614H3.74242L3.51889 15.7849C2.12666 17.1775 2.12666 19.4325 3.51889 20.8251C4.87919 22.1858 7.07611 22.2177 8.46834 20.9018C8.69825 22.6457 10.1927 24 12 24C13.8073 24 15.3018 22.6521 15.5317 20.9018C16.9303 22.2113 19.1208 22.1858 20.4811 20.8251C21.8733 19.4325 21.8733 17.1775 20.4811 15.7849L20.2576 15.5614H20.4364C22.4034 15.5614 24 13.9643 24 11.9968C23.9936 10.1698 22.6205 8.66223 20.8515 8.45781Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkBlack);
export default __webpack_public_path__ + "static/media/spark_black.53f30035334c41518d41952224a6201d.svg";
export { ForwardRef as ReactComponent };